import { LocationPreset } from '../project-view-users';
import type { UsersLocation } from './users-location.model';
import type { Location } from '../project-view-users/location.model';
import { getProjectViewUserLocations } from '../project-view-users/project-view-users.seed';

export interface GenerateUsersLocationOptions {
  readonly userId: number;
  readonly location?: Location;
}

export function generateUsersLocationObject({
  location = getProjectViewUserLocations(LocationPreset.SEATTLE),
  userId,
}: GenerateUsersLocationOptions): UsersLocation {
  return {
    id: userId,
    location,
  };
}
